import { AppActions } from './enum';
import { AppState, UserInfo } from './interface';
import { OverlayContent } from '../../enums/elementId';
import { PreMarketingType, ProviderType } from '../../enums/product';
import { Address, AvcResult, JarvisProduct } from '@vfde-sails/avc-core';

export const initStore = (payload: Partial<AppState>) => ({
    type: AppActions.INIT_STORE,
    payload,
} as const);

export const setLoading = (loading: boolean = true) => ({
    type: AppActions.SET_LOADING,
    loading,
} as const);

export const setAddress = (address: Address) => ({
    type: AppActions.SET_ADDRESS,
    address,
} as const);

export const deleteAddress = () => ({
    type: AppActions.DELETE_ADDRESS,
} as const);

export const resetOffersToPreVp = () => ({
    type: AppActions.RESET_TARIFFS,
} as const);

export const setError = (error: Error) => ({
    type: AppActions.ERROR,
    error,
} as const);

export const setTariffs = (tariffs: JarvisProduct[]) => ({
    type: AppActions.SET_TARIFFS,
    tariffs,
} as const);

export const setFamilyFriends = (familyAndFriends: boolean) => ({
    type: AppActions.SET_FAMILY_AND_FRIENDS,
    familyAndFriends,
} as const);

export const setActiveProviderType = (activeProviderType: ProviderType) => ({
    type: AppActions.SET_ACTIVE_PRODUCT_TYPE,
    activeProviderType,
} as const);

export const setSelectedTariffId = (id: string) => ({
    type: AppActions.SET_SELECTED_TARIFF,
    id,
} as const);

export const setGigakombi = (gigakombi: boolean) => ({
    type: AppActions.SET_GIGAKOMBI,
    gigakombi,
} as const);

export const setAvcResult = (result?: AvcResult) => ({
    type: AppActions.SET_AVC_RESULT,
    result,
} as const);

export const setPreMarketing = (preMarketing?: PreMarketingType) => ({
    type: AppActions.SET_PRE_MARKETING,
    preMarketing,
} as const);

export const overlayLoaded = () => ({
    type: AppActions.OVERLAY_LOADED,
} as const);

export const openOverlay = (overlayWrapper: OverlayContent, openAutoOverlay :boolean = false) => ({
    type: AppActions.OPEN_OVERLAY,
    payload: { overlayWrapper, openAutoOverlay },
} as const);

export const closeOverlay = () => ({
    type: AppActions.CLOSE_OVERLAY,
} as const);

export const setActiveOverlay = (activeOverlay: OverlayContent) => ({
    type: AppActions.SET_ACTIVE_OVERLAY,
    activeOverlay,
} as const);

export const resetProviderToDefault = () => ({
    type: AppActions.RESET_PROVIDER,
} as const);

export const setUserInfo = (userInfo?: UserInfo) => ({
    type: AppActions.SET_USER_INFO,
    userInfo,
} as const);

export type Actions = ReturnType<typeof initStore>
    | ReturnType<typeof setLoading>
    | ReturnType<typeof setError>
    | ReturnType<typeof setAddress>
    | ReturnType<typeof deleteAddress>
    | ReturnType<typeof setActiveProviderType>
    | ReturnType<typeof setAvcResult>
    | ReturnType<typeof setGigakombi>
    | ReturnType<typeof setFamilyFriends>
    | ReturnType<typeof setTariffs>
    | ReturnType<typeof setSelectedTariffId>
    | ReturnType<typeof overlayLoaded>
    | ReturnType<typeof openOverlay>
    | ReturnType<typeof closeOverlay>
    | ReturnType<typeof setActiveOverlay>
    | ReturnType<typeof resetProviderToDefault>
    | ReturnType<typeof resetOffersToPreVp>
    | ReturnType<typeof setPreMarketing>
    | ReturnType<typeof setUserInfo>;
